{
  "closeMonth": {
    "title": "Chốt sổ tháng",
    "prepayHint": "Thu trước theo lịch tháng này, bù trừ điểm danh tháng trước",
    "sessions": "buổi",
    "adjust": "Bù trừ",
    "flatFee": "Học phí tháng (cố định)",
    "pending": "còn {{count}} buổi chưa điểm danh",
    "summary": "{{payers}} hoá đơn · {{amount}}",
    "generate": "Tạo {{count}} hoá đơn nháp",
    "generating": "Đang tạo...",
    "empty": "Không có buổi nào chưa chốt trong tháng này",
    "emptyMaybeStale": "Tháng này không còn gì để chốt. Học viên bạn được dẫn tới đây đã có kỳ của tháng này rồi. Cảnh báo ở tháng {{from}} sẽ vẫn còn: kỳ kẹt đó không xử lý được từ màn hình này.",
    "done": "Đã tạo {{count}} hoá đơn nháp",
    "open": "Chốt sổ tháng",
    "reopen": "Mở lại kỳ",
    "reopenSuccess": "Đã mở lại kỳ {{month}}",
    "reopenBlocked": "Không thể mở lại: hoá đơn đã gửi/đã thanh toán. Hãy xử lý hoá đơn trước.",
    "reopenHistoryTitle": "Lịch sử mở lại tháng",
    "reopenHistoryItem": "Đã mở lại tháng {{month}} · xoá {{count}} hoá đơn nháp",
    "cancel": "Huỷ",
    "selectAll": "Chọn tất cả",
    "selectPayer": "Chọn {{name}}",
    "staleOpenItem": "{{student}} ({{client}}): chốt tháng {{month}} để bù trừ",
    "staleOpenItemUnbilled": "{{student}} ({{client}}): có {{count}} buổi tháng {{month}} chưa từng được tính tiền. Chốt tháng {{month}} trước.",
    "staleOpenMore": "và {{count}} học viên khác",
    "staleOpenGoto": "Chuyển sang tháng {{month}}",
    "backToInvoices": "Quay lại Hoá đơn",
    "willCreate": "Hoá đơn sẽ tạo",
    "pendingChip": "Tổng này có thể đổi sau khi điểm danh",
    "noneSelected": "Chọn ít nhất một người trả phí để tạo hoá đơn",
    "footerAriaLabel": "Tóm tắt hoá đơn sẽ tạo",
    "footerNote": "Tạo hoá đơn nháp, bạn xem lại rồi mới gửi",
    "gridTitle": "Đối soát điểm danh tháng {{month}}",
    "gridHint": "Ô ? là buổi chưa điểm danh, bấm vào để điểm danh nhanh",
    "reopenHistoryDesc": "Mỗi lần mở lại kỳ đều được ghi lại tại đây.",
    "reopenHistoryEmpty": "Chưa có lần mở lại kỳ nào.",
    "guidance": {
      "title": "Trước khi chốt",
      "countLabel": "{{count}} việc cần xem",
      "pendingTitle": "Còn {{count}} buổi tháng {{prev}} chưa điểm danh",
      "pendingDesc": "Chốt bây giờ thì {{count}} buổi đó không được bù trừ vào hoá đơn",
      "pendingAction": "Điểm danh ngay",
      "staleTitle": "Tháng {{month}} của {{names}} chưa chốt",
      "staleDesc": "Chốt tháng {{current}} trước sẽ khiến tháng {{month}} không bao giờ được bù trừ, chốt tháng cũ nhất trước",
      "staleNamesMore": "{{names}} và {{count}} người khác",
      "staleMonthsMore": "và {{count}} tháng khác cũng chưa chốt",
      "staleDetails": "Xem chi tiết",
      "quotaTitle": "Còn {{remaining}} lượt đối soát tự động tháng này",
      "quotaDesc": "Bạn đang tạo {{payerCount}} hoá đơn, phần vượt sẽ cần đối soát thủ công",
      "quotaAction": "Nâng gói"
    },
    "confirmDialog": {
      "title": "Xác nhận tạo hoá đơn",
      "description": "Sẽ tạo {{count}} hoá đơn nháp · Tổng {{amount}}.",
      "dueDateToggle": "Tùy chỉnh hạn thanh toán",
      "dueDateLabel": "Hạn thanh toán",
      "dueDatePast": "Hạn thanh toán phải là hôm nay hoặc sau đó.",
      "saveDefault": "Lưu ngày này làm mặc định cho các lần chốt sau",
      "saveDefaultDayTooHigh": "Chỉ lưu được mặc định cho ngày 1–28. Ngày này vẫn áp dụng cho lần tạo này.",
      "confirm": "Xác nhận",
      "confirming": "Đang tạo..."
    },
    "reopenPicker": {
      "title": "Chọn phụ huynh cần mở lại",
      "description": "Kỳ {{month}} sẽ được mở lại cho những phụ huynh bạn chọn dưới đây.",
      "warningDraftsLost": "Hoá đơn nháp của những phụ huynh được chọn sẽ bị xoá vĩnh viễn, kể cả phần bạn đã chỉnh tay.",
      "warningPerPayer": "Mỗi dòng là một hoá đơn (hoặc một phụ huynh, nếu chỉ có bù trừ công nợ), gồm tất cả những người con được tính trong đó.",
      "warningRecloseSelected": "Sau khi sửa xong, hãy chốt sổ lại và chỉ tick đúng những phụ huynh này.",
      "noInvoice": "(không có hoá đơn)",
      "blockedPending": "Đã gửi, không thể mở lại",
      "blockedPaid": "Đã thanh toán, không thể mở lại",
      "blockedSuccessor": "Kỳ sau đã chốt dựa trên kỳ này, không thể mở lại",
      "blockedOther": "Không còn là nháp, không thể mở lại",
      "confirm": "Mở lại {{count}} mục",
      "confirming": "Đang mở lại...",
      "empty": "Không có kỳ nào để mở lại trong tháng này",
      "genericError": "Không thể mở lại. Vui lòng thử lại."
    },
    "reopenHistoryAll": "Xem toàn bộ nhật ký thao tác"
  }
}
